import styles from "./PopupMenu.module.css";
import * as React from "react";
import {useEffect, useRef} from "react";
import {useOnClickOutside} from "../hooks/useClickOutside";

interface PopupMenuProps {
    isOpen: boolean;
    onClickOutside?: () => void;
    children?: React.ReactNode;
}

interface PopupMenuHeader {
    children?: React.ReactNode;
}

interface PopupMenuItemProps {
    onClick?: React.MouseEventHandler<HTMLDivElement>;
    children?: React.ReactNode;
}

export const PopupMenu = ({isOpen, children, onClickOutside}: PopupMenuProps) => {
    const menuRef = useRef(null);
    useOnClickOutside(document, isOpen ? menuRef : null, onClickOutside);
    return (
        <div className={styles.menu} ref={menuRef}
             style={{display: isOpen ? 'block' : 'none'}}>
            {children}
        </div>
    );
}

export const PopupMenuHeader = ({children}: PopupMenuHeader) => {
    return <div className={styles.header}>
        {children}
    </div>
}

export const PopupMenuItem = ({children, onClick} : PopupMenuItemProps)=>
{
    return <div className={styles.item} onClick={onClick}>
        {children}
    </div>
}

export const PopupMenuDivider = 
    () => <hr/>;